import { ApplicationConfig, ApplicationSection, FieldType } from '@bybeam/platform-types';

const SECTIONS: ApplicationSection[] = [
  {
    key: 'learnMore',
    name: 'Kiva Kansas City',
    overview: {
      description: 'Learn more about this program',
      title: 'Kiva Kansas City',
    },
    questionGroups: [
      {
        key: 'learnMore',
        name: 'Kiva Kansas City',
        questions: [
          {
            key: 'link',
            copy: { title: 'Kiva Kansas City' },
            layout: 'panel',
            fields: [
              {
                key: 'link',
                type: FieldType.Typography,
                copy: `
Established in 2005 as the world's first personal micro-lending website, Kiva offers crowdfunded microloans up $15,000 with no interest, fees, or collateral. Kiva conducts social underwritings - prioritizing character, not credit score. Kiva's community of $2M+ lenders, everyday individuals who pool lending contributions as little as $25, provide financial access to entrepreneurs in developing communities across the globe.

Kiva, the City of Kansas City, Missouri, and The Economic Development Corporation of Kansas City have partnered to establish a new Kiva hub at KCMO. The KivaKC Capital Access Manager can assist in the application, fundraising, and repayment processes.

To Qualify for Kiva Kansas City:

- Borrower and business must be U.S. based. 
- Borrower must be 18 years of age or older.
- Loan must be used for business purposes.
- Business must not be engaged in multi-level marketing, direct sales, pure financial investing, etc.
- Borrower or business must not be under foreclosure, bankruptcy, or under any liens.
- Home-based businesses are eligible for a Kiva loan.
- Businesses must have a business bank account connected to PayPal. Kiva loans are disbursed and repaid through PayPal.

To learn more contact [kansascity@local.kiva.org](mailto:kansascity@local.kiva.org), call [816-691-2120](tel:8166912120), or visit [kiva.org/borrow](https://kiva.org/borrow).
                `,
                props: { variant: 'largeBody', alignment: 'left' },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'attestation',
    name: 'Attestation',
    overview: {
      title: 'Attestation',
      description: '',
    },
    questionGroups: [
      {
        key: 'attestation',
        name: 'Attestation',
        questions: [
          {
            key: 'attestation',
            copy: { title: 'Attestation' },
            layout: 'panel',
            fields: [
              {
                key: 'attestation.info',
                type: FieldType.Typography,
                copy: 'I understand that to apply for this program, I must visit the external site: [https://www.kiva.org/borrow](https://www.kiva.org/borrow)',
                props: { variant: 'largeBody', alignment: 'center' },
              },
              {
                key: 'attestation.confirm',
                type: FieldType.Checkbox,
                copy: 'I confirm.',
              },
            ],
          },
        ],
      },
    ],
  },
];

const CONFIG: ApplicationConfig = {
  introPages: [],
  overrides: {
    statuses: [
      {
        status: 'Application',
        label: '',
        message:
          'This is an external program with its own application. To apply, visit [https://www.kiva.org/borrow](https://www.kiva.org/borrow).',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
      {
        status: 'InProgress',
        label: '',
        message:
          'This is an external program with its own application. To learn more & apply, visit [https://www.kiva.org/borrow](https://www.kiva.org/borrow).',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
    ],
    submission: {
      title: 'What happens next?',
      bullets: [
        {
          key: 'review',
          title: 'Application review',
          icon: 'description',
          description:
            'While we look at your application, we might send you an email to ask for more information or notify you of next steps',
        },
      ],
    },
  },
  sections: SECTIONS,
};

export default CONFIG;
